export const splitLongMessage = (text, maxLength) => {
  const parts = [];
  const totalLength = text.length;

  const numParts = Math.ceil(totalLength / maxLength);
  const idealPartLength = Math.ceil(totalLength / numParts);
  let start = 0;

  while (start < text.length) {
    let end = start + idealPartLength;

    if (end < text.length && text[end] !== ' ') {
      const lastSpace = text.lastIndexOf(' ', end);
      if (lastSpace > start) {
        end = lastSpace;
      }
    }

    if (end === start) {
      end = start + idealPartLength;
    }

    parts.push(text.substring(start, end).trim());
    start = end + 1;
  }

  if (parts.length > 1 && parts[parts.length - 1].length < 100) {
    parts[parts.length - 2] += ` ${parts.pop()}`;
  }

  return parts;
};
